import { gql } from '@apollo/client';

export default gql`
  query spaceUserLabel($userId: ID!) {
    spaceUser(id: $userId) {
      id
      email
      name
      surname
    }
  }
`;
